/**
 * Phase 10D: Client-side score display helpers for renewal comparison
 */

/**
 * Overall score 0–100 to label (Excellent / Good / Fair / Low)
 */
export function getScoreLabel(score) {
  if (score == null) return '—';
  const n = Number(score);
  if (n >= 85) return 'Excellent';
  if (n >= 70) return 'Good';
  if (n >= 50) return 'Fair';
  return 'Low';
}

/**
 * Color hint for score (for badges/charts)
 */
export function getScoreColor(score) {
  if (score == null) return 'default';
  const n = Number(score);
  if (n >= 85) return 'success';
  if (n >= 70) return 'primary';
  if (n >= 50) return 'warning';
  return 'error';
}

/**
 * Savings percentage to display text
 */
export function getSavingsText(savingsAmount, savingsPercentage) {
  if (savingsAmount == null && savingsPercentage == null) return null;
  const amt = savingsAmount != null ? `${formatNum(savingsAmount)}` : '';
  const pct = savingsPercentage != null ? `${formatNum(savingsPercentage)}%` : '';
  if (amt && pct) return `Save ${amt} (${pct})`;
  if (amt) return `Save ${amt}`;
  if (pct) return `Save ${pct}`;
  return null;
}

function formatNum(n) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Number(n));
}
